export default __webpack_public_path__ + "static/media/a037-student-t3-3.692b4195.svg";